module.exports = __webpack_public_path__ + "media/images/flags/us-982dfff1ca0cc95474cf6341e9f1aaf1.png";